// extracted by mini-css-extract-plugin
export var createdDate = "_m2-1";
export var divider = "_m2-2";
export var headerDivider = "_m2-3";
export var messagesCard = "_m2-0";
export var messagesContainer = "_m2-7";
export var messagesContainerWrapper = "_m2-4";
export var pointerCapturingButtonBoxes = "_m2-a";
export var showLeftPanelButton = "_m2-9";
export var showMoreButton = "_m2-c";
export var showMoreButtonContainer = "_m2-b";
export var summaryTitle = "_m2-6";
export var systemMessageCardWrapper = "_m2-d";
export var topButtons = "_m2-8";
export var withPadding = "_m2-5";